import type { HelpFile } from '../../types/help'
import { JobBuilderPageTestIds } from '../../../testids/JobBuilderPageTestIds'

export const jobBuilderPageHelp: HelpFile = {
  docPage: '/docs/jobs/job-builder',
  texts: {
    [JobBuilderPageTestIds.jobBuilderPage]: 'Visual editor for composing background jobs from a chain of tasks — drag tasks from the palette into the chain and configure each one.',
    [JobBuilderPageTestIds.badgeUnsaved]: 'The job has unsaved changes.',
    [JobBuilderPageTestIds.btnAddInput]: 'Add a key-value input parameter to the selected task.',
    [JobBuilderPageTestIds.btnApplyConfig]: 'Apply the current task configuration to the chain.',
    [JobBuilderPageTestIds.btnBack]: null,
    [JobBuilderPageTestIds.btnCancel]: null,
    [JobBuilderPageTestIds.btnConflictCancel]: 'Dismiss the version-conflict prompt and keep editing locally.',
    [JobBuilderPageTestIds.btnConflictReload]: 'Discard local edits and reload the latest version of the job from the server.',
    [JobBuilderPageTestIds.btnDiscard]: null,
    [JobBuilderPageTestIds.btnKeepEditing]: null,
    [JobBuilderPageTestIds.btnRetryPalette]: null,
    [JobBuilderPageTestIds.btnSave]: null,
    [JobBuilderPageTestIds.btnTestScript]: 'Run the inline script against test inputs and show the output.',
    [JobBuilderPageTestIds.builderError]: null,
    [JobBuilderPageTestIds.builderLoading]: null,
    [JobBuilderPageTestIds.builderLoadingPanels]: null,
    [JobBuilderPageTestIds.configBeanMethod]: 'Spring bean method invoked when this task runs.',
    [JobBuilderPageTestIds.configDelay]: 'Pause duration applied before the next task in the chain runs.',
    [JobBuilderPageTestIds.configGroovyScript]: 'Groovy script body executed when this task runs.',
    [JobBuilderPageTestIds.configReadonlyHint]: 'This configuration field is read-only because the task is locked or system-managed.',
    [JobBuilderPageTestIds.createJobDialog]: 'Dialog for creating a new job definition with a name, key, and description.',
    [JobBuilderPageTestIds.cronPreview]: 'Preview of the next scheduled run times for the entered cron expression.',
    [JobBuilderPageTestIds.editorScript]: null,
    [JobBuilderPageTestIds.emptyChain]: 'The task chain is empty — drag a task from the palette to begin.',
    [JobBuilderPageTestIds.hintNoTasks]: null,
    [JobBuilderPageTestIds.inputCronExpression]: 'Cron expression that defines when this job runs automatically.',
    [JobBuilderPageTestIds.inputDelayDuration]: 'Delay duration in seconds before the next task runs.',
    [JobBuilderPageTestIds.inputDelayName]: 'Display name for this delay step.',
    [JobBuilderPageTestIds.inputJobDescription]: 'Optional description explaining the purpose of this job.',
    [JobBuilderPageTestIds.inputJobKey]: 'Unique key identifying the job — used by the scheduler and logs.',
    [JobBuilderPageTestIds.inputJobName]: 'Human-readable name shown in lists and dashboards.',
    [JobBuilderPageTestIds.inputTaskName]: 'Display name for the selected task.',
    [JobBuilderPageTestIds.inputTimeout]: 'Maximum duration after which the task is forcefully cancelled.',
    [JobBuilderPageTestIds.paletteEmpty]: 'No tasks are available in the palette for this job type.',
    [JobBuilderPageTestIds.paletteError]: 'Failed to load the task palette — try refreshing.',
    [JobBuilderPageTestIds.paletteLoading]: 'Loading the available task types into the palette.',
    [JobBuilderPageTestIds.selectPriority]: 'Execution priority used when multiple jobs compete for resources.',
    [JobBuilderPageTestIds.switchSqlWriteAccess]: 'Allow this task to execute SQL statements that modify data — off by default for safety.',
    [JobBuilderPageTestIds.taskChainEditor]: 'Reorder, add, or remove tasks in the job chain.',
    [JobBuilderPageTestIds.taskConfigPanel]: 'Configuration panel for the currently selected task.',
    [JobBuilderPageTestIds.taskPalette]: 'Catalogue of available task types that can be dragged into the chain.',
    [JobBuilderPageTestIds.testError]: null,
    [JobBuilderPageTestIds.testOutput]: null,
  },
}
